module.exports = __webpack_public_path__ + "img/yifu.85ce6812.png";